import { useQuery } from "@tanstack/react-query";
import { getProjectWiseUploadedList } from "../../api/apiCallManager";

const useProjectSpecificFilesList = () => {
  return useQuery({
    queryKey: ["_filesList"],
    queryFn: getProjectWiseUploadedList,
  });
};

export default useProjectSpecificFilesList;
